import tokenService from './TokenService';

class ApiService {
  constructor(baseURL) {
    this.baseURL = baseURL || 'https://rxzycbkuv7.execute-api.eu-west-1.amazonaws.com/dev';
    // List of endpoints that should be accessible without authentication
    this.publicEndpoints = [
      // '/pricing',
      '/tiers'
      // Add other public endpoints here
    ];
  }

  async request(endpoint, options = {}) {
    // Check if this is a public endpoint
    const isPublicEndpoint = this.publicEndpoints.some((publicPath) =>
      endpoint.startsWith(publicPath)
    );

    // Define headers
    let headers = {
      'Content-Type': 'application/json',
      ...options.headers
    };

    // For protected endpoints, verify authentication
    if (!isPublicEndpoint) {
      // Ensure the token is valid before making the request
      const isValid = await tokenService.validateToken();
      if (!isValid) {
        // Check if we're on the tiers page - don't redirect in that case
        if (window.location.pathname === '/tiers') {
          // Allow the request to continue without authentication
          console.log('Public access to tiers page, continuing without authentication');
        } else {
          // Redirect to login if token is invalid
          window.location.href = '/sign-in';
          throw new Error('User is not authenticated');
        }
      }

      // Add authorization header if we're authenticated
      const accessToken = tokenService.getAccessToken();
      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
      }
    }

    // Build the request
    const requestOptions = {
      ...options,
      headers
    };

    try {
      const response = await fetch(`${this.baseURL}${endpoint}`, requestOptions);

      // If unauthorized and it's not a public endpoint, refresh token and try again
      if (response.status === 401 && !isPublicEndpoint) {
        const refreshed = await tokenService.refreshToken();
        if (refreshed) {
          // Retry with new token
          headers.Authorization = `Bearer ${tokenService.getAccessToken()}`;
          const retryResponse = await fetch(`${this.baseURL}${endpoint}`, {
            ...requestOptions,
            headers
          });

          if (retryResponse.ok) {
            return retryResponse.json();
          } else {
            throw new Error(`API error: ${retryResponse.status}`);
          }
        } else {
          // If refresh fails, redirect to login
          tokenService.logout();
          throw new Error('Authentication failed');
        }
      }

      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Helper methods for common HTTP methods
  async get(endpoint) {
    return this.request(endpoint, { method: 'GET' });
  }

  async post(endpoint, data) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async put(endpoint, data) {
    return this.request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  async delete(endpoint) {
    return this.request(endpoint, { method: 'DELETE' });
  }
}

export const apiService = new ApiService();
export default apiService;
